export const GOAL_CATEGORIES = {
  client_satisfaction: "Client Satisfaction",
  professional_goals: "Professional Goals",
  personal_goals: "Personal Goals",
};

export const GOAL_CATEGORY_LIST = Object.values(GOAL_CATEGORIES);

export const CATEGORY_FIELD_MAP = {
  [GOAL_CATEGORIES.client_satisfaction]: "client_satisfaction_percentage",
  [GOAL_CATEGORIES.professional_goals]: "professional_goals_percentage",
  [GOAL_CATEGORIES.personal_goals]: "personal_goals_percentage",
};

export const GOAL_STATUS_LABELS = {
  draft: "Draft – needs setup confirmation",
  active: "Active",
  pending_review: "Pending review confirmation",
  completed: "Completed",
};

// Shown wherever a current status is expected but the engineer has no
// unfinished period (never had goals, or the last one is completed).
export const NO_CURRENT_GOAL_LABEL = "No new goals set up";

export const GOAL_STATUS_COLORS = {
  draft: "warning",
  active: "success",
  pending_review: "warning",
  completed: "secondary",
};

export const ENGINEERS_TABLE_COLUMNS = [
  { name: "engineer", align: "left" },
  { name: "current_goal", align: "left" },
  { name: "previous_score", align: "left" },
  { name: "last_set_by", align: "left" },
  { name: "last_reviewed_by", align: "left" },
  { name: "actions", align: "center" },
];

export const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const GOALS_MESSAGES = {
  adminNotFound: "Admin not found.",
  categorySumMismatch: "Category percentages must sum to the total percentage.",
  weightSumMismatch: "goal weights must sum to that category's allocated percentage.",
  templateRequired: "Please select a period template.",
  descriptionRequired: "Every goal needs a description.",
};

export const percentageSum = (values) =>
  Math.round(values.reduce((sum, value) => sum + Number(value || 0), 0) * 100) / 100;

export const approxEqual = (a, b) => Math.abs(Number(a) - Number(b)) <= 0.01;

// Strips any "-" as it's typed, so numeric fields that should never be
// negative (weights, scores, percentages) can't accept one at all.
export const stripNegative = (rawValue) => String(rawValue).replace(/-/g, "");

// Hides the browser's up/down spinner on number inputs (typing only).
export const noSpinnerSx = {
  "& input[type=number]": { MozAppearance: "textfield" },
  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
    { WebkitAppearance: "none", margin: 0 },
};
